import type { ComponentType } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

interface GridUIProps {
  ChildrenComponent: ComponentType<{
    item: { children: DocumentItem[] };
    subdomainNetworkUrl?: string;
  }>;
  item: DocumentItem<SectionItemAttributes>;
  subdomainNetworkUrl?: string;
}

const GridUI = ({
  ChildrenComponent,
  item,
  subdomainNetworkUrl,
}: GridUIProps) => {
  const [
    firstImage,
    secondImage,
    thirdImage,
    fourthImage,
    fifthImage,
    sixthImage,
    seventhImage,
    eighthImage,
  ] = item.children || [];

  return (
    <StyledGridContainer data-testid="gallery-template-grid-component">
      <RowWrapper>
        <ChildrenComponent
          item={{ children: [firstImage] }}
          subdomainNetworkUrl={subdomainNetworkUrl}
        />
        <ColumnWrapper>
          <ChildrenComponent
            item={{ children: [secondImage] }}
            subdomainNetworkUrl={subdomainNetworkUrl}
          />
          <ChildrenComponent
            item={{ children: [thirdImage] }}
            subdomainNetworkUrl={subdomainNetworkUrl}
          />
        </ColumnWrapper>
        <ChildrenComponent
          item={{ children: [fourthImage] }}
          subdomainNetworkUrl={subdomainNetworkUrl}
        />
      </RowWrapper>

      <RowWrapper mt={{ s: 6, m: 5, l: 6 }}>
        <ColumnWrapper>
          <ChildrenComponent
            item={{ children: [fifthImage] }}
            subdomainNetworkUrl={subdomainNetworkUrl}
          />
          <ChildrenComponent
            item={{ children: [sixthImage] }}
            subdomainNetworkUrl={subdomainNetworkUrl}
          />
        </ColumnWrapper>
        <ChildrenComponent
          item={{ children: [seventhImage] }}
          subdomainNetworkUrl={subdomainNetworkUrl}
        />
        <ChildrenComponent
          item={{ children: [eighthImage] }}
          subdomainNetworkUrl={subdomainNetworkUrl}
        />
      </RowWrapper>
    </StyledGridContainer>
  );
};

export default GridUI;

const StyledGridContainer = styled(Box).attrs(() => ({
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  py: 6,
  width: '100%',
}))``;

const RowWrapper = styled(Box).attrs(() => ({
  flexDirection: { s: 'column', m: 'row' },
  justifyContent: 'center',
  width: '100%',
}))``;

const ColumnWrapper = styled(Box).attrs(() => ({
  flexDirection: { s: 'row', m: 'column' },
  justifyContent: 'space-between',
  mr: { s: 0, m: 5, l: 6 },
  width: {
    s: '100%',
    m: 'calc(14% + 2px)',
    l: 'calc(14% + 6px)',
    xl: 'calc(14% + 17px)',
  },
}))``;
